module.exports = __webpack_public_path__ + "static/img/p3_img4.7ba8d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3_img4.png
// module id = BGf1
// module chunks = 0